import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import {
  AlertService,
  ButtonLoadingDirective,
  CardActionsComponent,
  CardComponent,
  CardContentComponent,
} from '@gains-com/ui-angular';
import { MatButton } from '@angular/material/button';
import { DialogRef } from '@angular/cdk/dialog';
import { DeviceModeViewService } from '../../core/view-states/device-mode-view.service.js';
import { UserViewService } from '../../core/view-states/user-view.service.js';

@Component({
  selector: 'app-region-restriction-dialog',
  templateUrl: './region-restriction-dialog.component.html',
  styleUrl: './region-restriction-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CardActionsComponent, CardComponent, CardContentComponent, MatButton, ButtonLoadingDirective],
})
export class RegionRestrictionDialogComponent {
  private readonly _dialog = inject(DialogRef);
  private readonly _alert = inject(AlertService);
  private readonly _userView = inject(UserViewService);
  private readonly _deviceModeView = inject(DeviceModeViewService);

  checkLocationInProgress = signal(false);

  close() {
    this._dialog.close();
  }

  // Re-checks via GPS attest (v4.1: region restriction is decided from a
  // GPS-verified location, never IP) — same pattern as region-restricted-notice.
  protected async validate() {
    this.checkLocationInProgress.set(true);
    try {
      await this._deviceModeView.attestCurrentPosition();
      if (this._deviceModeView.source() === 'gps' && !this._deviceModeView.regionRestricted()) {
        this._alert.notifySuccess('Gains.com is available', 'You are able to use Gains.com.');
        this._userView.updateUser({
          region_restricted: false
        });
        this.close();
      } else {
        this._alert.notifyWarning('Region is Restricted', 'Your detected location is still restricted.');
      }
    } catch (err: any) {
      if (err?.error?.error === 'RATE_LIMIT_EXCEEDED') {
        this._alert.notifyWarning('Too many requests', 'You have made too many requests. Please try again later.');
      } else {
        this._alert.notifyWarning(
          'Location check failed',
          'We could not verify your device location. Allow location access in your browser and try again.'
        );
      }
    } finally {
      this.checkLocationInProgress.set(false);
    }
  }
}
